module.exports = __webpack_public_path__ + "static/media/m_w_hw_12.3facce50.png";